import { render, staticRenderFns } from "./ModalCadastroFaixaAno.vue?vue&type=template&id=764bb4e8"
import script from "./ModalCadastroFaixaAno.vue?vue&type=script&lang=js"
export * from "./ModalCadastroFaixaAno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports